import { useEffect, useState } from 'react';
import type { IllustrationBundleBootstrap } from '../services/api';
import { loadIllustrationIndex } from '../services/illustrations';

export function useIllustrationIndex() {
    const [data, setData] = useState<IllustrationBundleBootstrap | null>(null);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        const controller = new AbortController();
        setError(false);
        loadIllustrationIndex(controller.signal).then(value => { if (!controller.signal.aborted) setData(value); })
            .catch(() => { if (!controller.signal.aborted) setError(true); });
        return () => controller.abort();
    }, [attempt]);
    return { data, error, retry: () => setAttempt(value => value + 1) };
}
